function envString(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (
    (raw.startsWith('"') && raw.endsWith('"')) ||
    (raw.startsWith("'") && raw.endsWith("'"))
  ) {
    return raw.slice(1, -1).trim();
  }
  return raw;
}

function normalizedBaseUrl(value: unknown): string {
  const raw = envString(value);
  if (!raw) return '';
  return raw.endsWith('/') ? raw.slice(0, -1) : raw;
}

/**
 * Two base URLs:
 * - chartApiBaseUrl  → the standalone charting backend (/v1/chart-engine/*)
 * - vaartaApiBaseUrl → the Vaarta platform (api registry, data-studio, auth)
 *
 * Both default to "" so requests go to same-origin relative paths and the Vite
 * dev proxy (or your reverse proxy) routes `/chart-api/*` and `/vaarta-api/*`.
 */
export const appEnv = {
  chartApiBaseUrl: normalizedBaseUrl(import.meta.env.VITE_CHART_API_BASE_URL) || '/chart-api',
  vaartaApiBaseUrl: normalizedBaseUrl(import.meta.env.VITE_VAARTA_API_BASE_URL) || '/vaarta-api',
  appTimezone: envString(import.meta.env.VITE_APP_TIMEZONE) || 'Asia/Kolkata',
  // Where the forwarded platform bearer is read from. Named for the days it was
  // a session key; with sign-in gone it is only a credential to pass upstream,
  // and it stays on Vaarta's key so a token left by the platform is still found.
  authTokenStorageKey: envString(import.meta.env.VITE_AUTH_TOKEN_STORAGE_KEY) || 'vaarta_token',
};
